import { type RouteRecordRaw } from 'vue-router';

export enum MODULE_ROUTE {
  index = 'CheckAntiSpyTest',
  quiz = 'CheckAntiSpyTestQuiz',
  protectLink = 'CheckAntiSpyTestProtectLink',
  protectPersonalData = 'CheckAntiSpyTestProtectPersonalData',
  samePassword = 'CheckAntiSpyTestsSamePassword',
  protectInfo = 'CheckAntiSpyTestsProtectInfo',
  help = 'CheckAntiSpyTestsHelp',
  reviews = 'CheckAntiSpyTestsReviews',
  protectEverything = 'CheckAntiSpyTestsProtectEverything',
  checkData = 'CheckAntiSpyTestsCheckData',
  onlineThreats = 'CheckAntiSpyTestsOnlineThreats',
  loader = 'CheckAntiSpyTestLoader',
  result = 'CheckAntiSpyTestResult',
  preparing = 'CheckAntiSpyTestPreparing',
  auth = 'CheckAntiSpyTestAuth',
  payment = 'CheckAntiSpyTestPayment',
}

function preloadModule(name: MODULE_ROUTE) {
  const parentRoute = routes.find((layoutRoute) =>
    layoutRoute.children?.find((route) => route.name === name),
  );

  const route = parentRoute?.children?.find((route) => route.name === name);

  if (route && 'component' in route && typeof route.component === 'function') {
    (route.component as unknown as () => void)();
  }
}

export const routes: RouteRecordRaw[] = [
  {
    path: '/:lang?/pricing/check-antispy/',
    component: () =>
      import('@/modules/check-antispy-test/layout/LayoutPage.vue'),
    meta: {
      i18nAlias: 'pricing',
    },
    children: [
      {
        path: '',
        name: MODULE_ROUTE.index,
        component: () =>
          import('@/modules/check-antispy-test/pages/index/PageSafeOnline.vue'),
        meta: {
          abtestGroup: 1,
        },
        beforeEnter() {
          setTimeout(() => {
            Object.values(MODULE_ROUTE)
              .filter((moduleName) => moduleName !== MODULE_ROUTE.index)
              .forEach((moduleName) =>
                preloadModule(moduleName as MODULE_ROUTE),
              );
          }, 1000);
        },
      },
      {
        path: 'protect-link/',
        name: MODULE_ROUTE.protectLink,
        component: () =>
          import('@/modules/check-antispy-test/pages/protect-link/PageSafeOnlineProtectLink.vue'),
      },
      {
        path: 'protect-personal-data/',
        name: MODULE_ROUTE.protectPersonalData,
        component: () =>
          import('@/modules/check-antispy-test/pages/protect-personal-data/PageSafeOnlineProtectPersonalData.vue'),
      },
      {
        path: 'same-password/',
        name: MODULE_ROUTE.samePassword,
        component: () =>
          import('@/modules/check-antispy-test/pages/same-password/PageSafeOnlineSamePassword.vue'),
      },
      {
        path: 'protect-info/',
        name: MODULE_ROUTE.protectInfo,
        component: () =>
          import('@/modules/check-antispy-test/pages/protect-info/PageSafeOnlineProtectInfo.vue'),
      },
      {
        path: 'help/',
        name: MODULE_ROUTE.help,
        component: () =>
          import('@/modules/check-antispy-test/pages/help/PageSafeOnlineHelp.vue'),
      },
      {
        path: 'online-threats/',
        name: MODULE_ROUTE.onlineThreats,
        component: () =>
          import('@/modules/check-antispy-test/pages/online-threats/PageSafeOnlineOnlineThreats.vue'),
      },
      {
        path: 'reviews/',
        name: MODULE_ROUTE.reviews,
        component: () =>
          import('@/modules/check-antispy-test/pages/reviews/PageSafeOnlineReviews.vue'),
      },
      {
        path: 'protect-everything/',
        name: MODULE_ROUTE.protectEverything,
        component: () =>
          import('@/modules/check-antispy-test/pages/protect-everything/PageSafeOnlineProtectEverything.vue'),
      },
      {
        path: 'check-data/',
        name: MODULE_ROUTE.checkData,
        component: () =>
          import('@/modules/check-antispy-test/pages/check-data/PageSafeOnlineCheckData.vue'),
      },
      {
        path: 'quiz/',
        name: MODULE_ROUTE.quiz,
        component: () =>
          import('@/modules/check-antispy-test/pages/quiz/PageQuiz.vue'),
      },
      {
        path: 'loader/',
        name: MODULE_ROUTE.loader,
        component: () =>
          import('@/modules/check-antispy-test/pages/loader/PageLoader.vue'),
      },
      {
        path: 'result/',
        name: MODULE_ROUTE.result,
        component: () =>
          import('@/modules/check-antispy-test/pages/result/PageResult.vue'),
      },
      {
        path: 'preparing/',
        name: MODULE_ROUTE.preparing,
        component: () =>
          import('@/modules/check-antispy-test/pages/preparing/PagePreparing.vue'),
      },
      {
        path: 'auth/',
        name: MODULE_ROUTE.auth,
        component: () =>
          import('@/modules/check-antispy-test/pages/auth/PageAuth.vue'),
      },
      {
        path: 'payment/',
        name: MODULE_ROUTE.payment,
        component: () =>
          import('@/modules/check-antispy-test/pages/payment/PagePayment.vue'),
        meta: {
          i18nAlias: 'pricing',
        },
      },
    ],
  },
];
